import * as React from "react";
import type { SVGProps } from "react";
const SvgIconOutdoorSpace = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 21 21"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.21.03q-.12.03-.2.08C9.85.2.32 7.36.24 7.45q-.18.17-.22.46c-.07.4.2.81.6.93.1.03.73.04 4.52.04h4.41v5.55c0 3.9.01 5.6.03 5.7q.04.25.24.44.3.31.75.23c.19-.03.3-.1.45-.23.14-.14.2-.26.24-.45.01-.1.02-1.78.02-5.7V8.89h4.46l4.46-.01.13-.07q.28-.14.42-.43c.06-.13.07-.18.07-.34 0-.2-.04-.33-.16-.52-.04-.05-1.8-1.39-4.9-3.71L10.83.1c-.1-.05-.32-.11-.42-.11zM6.93 4.55 3.45 7.16h13.94l-3.48-2.6-3.5-2.62zm-6.2 5.82q-.25.03-.46.23c-.14.14-.2.26-.24.45-.04.2-.04 8.87 0 9.07.06.36.33.62.69.68.17.04.39 0 .54-.07s.34-.29.4-.45l.06-.13V18.5l.01-1.65h1.22c1.18 0 1.23 0 1.36.05.18.06.35.24.42.41.05.13.05.18.05 1.4 0 1.3 0 1.47.1 1.64.16.33.54.52.91.45.2-.03.31-.1.45-.23.27-.27.27-.3.26-1.98-.01-1.16-.02-1.37-.05-1.52-.21-.9-.86-1.6-1.73-1.84-.31-.1-.63-.11-1.87-.11H1.73v-2.05c-.01-2.28 0-2.13-.18-2.37-.19-.25-.5-.38-.82-.33m19.1 0q-.25.03-.46.24-.2.19-.24.47c-.01.08-.02.96-.02 2.09v1.95h-1.13c-1.24 0-1.55.02-1.87.1-.72.21-1.34.78-1.61 1.49-.15.39-.15.4-.16 1.88-.02 1.68-.01 1.71.25 1.98.14.14.26.2.45.23.18.04.4 0 .55-.07.12-.06.3-.25.37-.37.09-.18.1-.33.1-1.65 0-1.22 0-1.27.05-1.4.06-.17.24-.35.42-.41.12-.05.17-.05 1.35-.05h1.23v1.56c0 1.63 0 1.77.1 1.95.06.12.25.3.37.37.33.17.77.09 1.01-.18q.18-.18.22-.44c.02-.11.02-1.47.02-4.62 0-4.08-.01-4.47-.05-4.57-.15-.38-.53-.61-.95-.55"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconOutdoorSpace;
